import React from 'react';
import { BsCurrencyDollar } from 'react-icons/bs';
import { FaHistory } from 'react-icons/fa';

export const userProfileData = [
  {
    icon: <BsCurrencyDollar />,
    title: 'My Profile',
    desc: 'Account Settings',
    iconColor: '#03C9D7',
    iconBg: '#E5FAFB',
  },
  {
    icon: <FaHistory />,
    title: 'My Actions',
    desc: 'Last Actions',
    iconColor: 'rgb(0, 194, 146)',
    iconBg: 'rgb(235, 250, 242)',
  },
];
